export default {
  root: {
    width: 40,
    height: 40,
    margin: 'auto',
    marginTop: 200
  }
};
